module.exports = __webpack_public_path__ + "src/assets/img/lock-green.70a79d99.svg";